export default __webpack_public_path__ + "static/media/nflStaff11.49c49a15.jpg";